import { render, staticRenderFns } from "./InfromacioRequerimientoForm.vue?vue&type=template&id=a8bf23b2&"
import script from "./InfromacioRequerimientoForm.vue?vue&type=script&lang=ts&"
export * from "./InfromacioRequerimientoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a8bf23b2', component.options)
    } else {
      api.reload('a8bf23b2', component.options)
    }
    module.hot.accept("./InfromacioRequerimientoForm.vue?vue&type=template&id=a8bf23b2&", function () {
      api.rerender('a8bf23b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EquiposEnTerreno/InfromacioRequerimientoForm.vue"
export default component.exports